var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('h4',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm.$t('call-reporting.demo.call-support.title')))]),_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('action-denied.role-restriction'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }